export const finpspFormStyles = {
  '& .MuiDialogContent-root': {
    // The cashier owns scrolling; let floating labels extend above the first field.
    overflow: 'visible',
  },
  '& .MuiDialogContent-root > .MuiStack-root': {
    py: 0,
    gap: 2,
    '& > :not(style) ~ :not(style)': {
      mt: 0,
    },
  },
  '& .MuiDialogActions-root': {
    pt: 2,
    pb: 0,
  },
};
